import axios from 'axios';
import { detect } from 'detect-browser';
const browser = detect();
const browserUID = (() => {
    var nav = window.navigator;
    var screen = window.screen;
    var guid = String(nav.mimeTypes.length);
    guid += nav.userAgent.replace(/\D+/g, '');
    guid += nav.plugins.length;
    guid += screen.height || '';
    guid += screen.width || '';
    guid += screen.pixelDepth || '';
    return guid;
})();
// auth http client using firebase token
const axAuth = axios.create({
    baseURL: process.env.VUE_APP_AUTH_BASE_URL,
    withCredentials: true,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
    data: {
        device_uid: browserUID,
        device_type: 'browser',
        device_platform: browser ? browser.os : 'unknown',
        device_os_version: (browser ? browser.name : 'unknown') + '_' + (browser ? browser.version : 'unknown')
    }
});
// auth http client using backend token
const axAuthBEToken = axios.create({
    baseURL: process.env.VUE_APP_AUTH_BASE_URL,
    withCredentials: true,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
});
export default {
    httpAuth: axAuth,
    httpAuthBEToken: axAuthBEToken,
    setFBToken(token) {
        this.httpAuth.defaults.headers['Authorization'] = 'token ' + token;
    },
    setBEToken(token) {
        this.httpAuthBEToken.defaults.headers['Authorization'] = 'token ' + token;
    },
    async login(data) {
        data = data || {};
        try {
            const res = await this.httpAuth.post('/auth_firebase/login', data);
            return res.data.data;
        }
        catch (err) {
            throw err;
        }
    },
    async updateProfile(data) {
        data = data || {};
        try {
            const res = await this.httpAuthBEToken.post('/auth_firebase/profile/update', data);
            return res.data.data;
        }
        catch (err) {
            throw err;
        }
    },
    async deleteProfile(profileID) {
        try {
            const res = await this.httpAuthBEToken.post('/auth_firebase/profile/delete', { id: profileID });
            return res.data.data;
        }
        catch (err) {
            throw err;
        }
    },
    async deleteAccount(accountID) {
        try {
            const res = await this.httpAuthBEToken.post('/auth_firebase/account/delete', { id: accountID });
            return res.data.data;
        }
        catch (err) {
            throw err;
        }
    }
};
